export default "__VITE_ASSET__9fb9be95__"